var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { utilities } from "../../../../utilities/utilities";
import { Element } from "../../../../element/element";
import { learningLounge } from "../../../../api";
import { Modal } from "../../../../component/modal";
import { authentication } from "./authentication";
import { Spinner } from "../../../../component/spinner";
var regexTest = function (value, pattern) {
    return value.match(pattern) != null ? true : false;
};
var highlite = function (selector, evaluation) {
    if (regexTest(selector.value, /\S+/) && (evaluation != null ? evaluation : false)) {
        selector.classList.remove('bg-light');
        selector.classList.add('text-white', 'bg-success');
    }
    else {
        selector.classList.add('bg-light');
        selector.classList.remove('text-white', 'bg-success');
    }
};
var emailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
var passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[a-zA-Z\d!@\-\?]{8,12}$/;
var nameRegex = /^.+$/;
var onKeyup = function (selector, regex) {
    var handleValidation = function (selector, regex) {
        highlite(selector, regex ? regexTest(selector.value, regex) : true);
    };
    selector.addEventListener('keyup', function () { return handleValidation(selector, regex); });
    selector.addEventListener('blur', function () { return handleValidation(selector, regex); });
};
export var register = function (_a) {
    var _b = _a === void 0 ? {} : _a, _c = _b.returnUrl, returnUrl = _c === void 0 ? "" : _c;
    var register = {
        formElement: null,
        errorElement: null,
        errorWrapper: null,
        get formValue() {
            return {
                username: register.username.value,
                password: register.password.value,
                firstName: register.firstName.value,
                lastName: register.lastName.value,
            };
        },
        get formIsValid() {
            return [
                register.username,
                register.password,
                register.firstName,
                register.lastName
            ].every(function (x) { return x.isValid; });
        },
        username: {
            element: null,
            get value() {
                var _a;
                return (_a = register.username.element) === null || _a === void 0 ? void 0 : _a.value;
            },
            get isValid() {
                return regexTest(register.username.value, emailRegex);
            },
            render: function () {
                register.username.element = new Element({
                    composer: {
                        content: utilities.html(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n                            <input class=\"form-control\" type=\"email\" placeholder=\"Email (used as your username)\"/>\n                        "], ["\n                            <input class=\"form-control\" type=\"email\" placeholder=\"Email (used as your username)\"/>\n                        "])))
                    },
                    events: {
                        keyup: function () {
                            onKeyup(register.username.element, emailRegex);
                        }
                    }
                }).render();
                return register.username.element;
            }
        },
        password: {
            element: null,
            get value() {
                var _a;
                return (_a = register.password.element) === null || _a === void 0 ? void 0 : _a.value;
            },
            get isValid() {
                return regexTest(register.password.value, passwordRegex);
            },
            render: function () {
                register.password.element = new Element({
                    composer: {
                        content: utilities.html(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n                            <input class=\"form-control\" type=\"password\" placeholder=\"Password\" />\n                        "], ["\n                            <input class=\"form-control\" type=\"password\" placeholder=\"Password\" />\n                        "])))
                    },
                    events: {
                        keyup: function () {
                            onKeyup(register.password.element, passwordRegex);
                        }
                    }
                }).render();
                return register.password.element;
            }
        },
        firstName: {
            element: null,
            get value() {
                var _a;
                return (_a = register.firstName.element) === null || _a === void 0 ? void 0 : _a.value;
            },
            get isValid() {
                return regexTest(register.firstName.value, nameRegex);
            },
            render: function () {
                register.firstName.element = new Element({
                    composer: {
                        content: utilities.html(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n                            <input class=\"form-control\" placeholder=\"First Name\"/>\n                        "], ["\n                            <input class=\"form-control\" placeholder=\"First Name\"/>\n                        "])))
                    },
                    events: {
                        keyup: function () {
                            onKeyup(register.firstName.element);
                        }
                    }
                }).render();
                return register.firstName.element;
            }
        },
        lastName: {
            element: null,
            get value() {
                var _a;
                return (_a = register.lastName.element) === null || _a === void 0 ? void 0 : _a.value;
            },
            get isValid() {
                return regexTest(register.lastName.value, nameRegex);
            },
            render: function () {
                register.lastName.element = new Element({
                    composer: {
                        content: utilities.html(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n                            <input class=\"form-control\" placeholder=\"Last Name\"/>\n                        "], ["\n                            <input class=\"form-control\" placeholder=\"Last Name\"/>\n                        "])))
                    },
                    events: {
                        keyup: function () {
                            onKeyup(register.lastName.element);
                        }
                    }
                }).render();
                return register.lastName.element;
            }
        },
        submit: {
            element: null,
            render: function () {
                register.submit.element = new Element({
                    composer: {
                        content: utilities.html(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n                            <button type=\"submit\" disabled class=\"btn  position-relative btn-lg btn-primary bg-primary text-white d-flex justify-content-center align-items-center gap-3\">\n                                Create account\n                            </button>\n                        "], ["\n                            <button type=\"submit\" disabled class=\"btn  position-relative btn-lg btn-primary bg-primary text-white d-flex justify-content-center align-items-center gap-3\">\n                                Create account\n                            </button>\n                        "])))
                    }
                }).render();
                return register.submit.element;
            }
        },
        onSubmit: function () {
            return __awaiter(this, void 0, void 0, function () {
                var aft, formToken, _spinner, username, password, firstName, lastName, params, isRootTest_1, path, response, text, data_1, responseRange, newError, modal, err_1, newError;
                var _a, _b, _c, _d, _e, _f, _g;
                return __generator(this, function (_h) {
                    switch (_h.label) {
                        case 0:
                            if (!this.formIsValid)
                                return [2 /*return*/];
                            return [4 /*yield*/, fetch("".concat(learningLounge, "/cerberus/aft"), {
                                    credentials: "include"
                                })];
                        case 1:
                            aft = _h.sent();
                            return [4 /*yield*/, aft.json()];
                        case 2:
                            formToken = (_h.sent()).formToken;
                            _spinner = new Spinner({}).render();
                            _spinner.classList.add('position-absolute', 'end-0', 'top-0', 'bottom-0', 'me-3', 'h-100', 'd-flex', 'justify-content-center', 'align-items-center');
                            (_a = register.submit.element) === null || _a === void 0 ? void 0 : _a.appendChild(_spinner);
                            username = (_b = register.username.value) === null || _b === void 0 ? void 0 : _b.trim();
                            password = (_c = register.password.value) === null || _c === void 0 ? void 0 : _c.trim();
                            firstName = (_d = register.firstName.value) === null || _d === void 0 ? void 0 : _d.trim();
                            lastName = (_e = register.lastName.value) === null || _e === void 0 ? void 0 : _e.trim();
                            params = new URLSearchParams();
                            params.append("UserName", username);
                            params.append("Password", password);
                            params.append("FirstName", firstName);
                            params.append("LastName", lastName);
                            params.append("__RequestVerificationToken", formToken);
                            params.append("ReturnUrl", returnUrl !== null && returnUrl !== void 0 ? returnUrl : "");
                            _h.label = 3;
                        case 3:
                            _h.trys.push([3, 8, , 9]);
                            isRootTest_1 = window.location.hostname === "learninglounge.com" ||
                                window.location.hostname === "localhost" ||
                                window.location.hostname === "127.0.0.1" ||
                                window.location.hostname === "localhost:44309" ||
                                window.location.hostname === "www.learninglounge.com" ||
                                window.location.hostname === "staging.learninglounge.com" ||
                                window.location.hostname === "www.staging.learninglounge.com";
                            path = "".concat(learningLounge, "/cerberus/account/register");
                            return [4 /*yield*/, fetch(path, {
                                    method: "POST",
                                    credentials: "include",
                                    headers: {
                                        "Content-Type": "application/x-www-form-urlencoded",
                                    },
                                    body: params.toString(),
                                })];
                        case 4:
                            response = _h.sent();
                            console.log(response, 'response');
                            if (!!response.ok) return [3 /*break*/, 6];
                            console.error("HTTP error:", response.status, response.statusText);
                            return [4 /*yield*/, response.text()];
                        case 5:
                            text = _h.sent();
                            alert("Login failed: " + text);
                            _spinner.remove();
                            return [2 /*return*/];
                        case 6: return [4 /*yield*/, response.json().catch(function () { return null; })];
                        case 7:
                            data_1 = _h.sent();
                            responseRange = data_1.responseMetaData[0].responseRange;
                            if (responseRange != 1) {
                                newError = utilities.html(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n                        <div class=\"text-danger my-3 toast-danger border border-danger   p-2 rounded shadow-sm\">\n                            <div class=\" d-flex align-items-start gap-2\">\n                                <i class=\"fa-light fa-exclamation-circle mt-1\"></i>\n                                ", "\n                            </div>\n                        </div>\n                    "], ["\n                        <div class=\"text-danger my-3 toast-danger border border-danger   p-2 rounded shadow-sm\">\n                            <div class=\" d-flex align-items-start gap-2\">\n                                <i class=\"fa-light fa-exclamation-circle mt-1\"></i>\n                                ", "\n                            </div>\n                        </div>\n                    "])), data_1.responseMetaData[0].responseDesc);
                                (_f = register.errorWrapper) === null || _f === void 0 ? void 0 : _f.appendChild(newError);
                                register.errorElement = newError;
                                _spinner.remove();
                            }
                            else {
                                modal = new Modal({
                                    composer: {
                                        classes: {
                                            dialog: 'account-created-modal d-flex justify-content-center',
                                            content: "",
                                            body: '',
                                            footer: 'position-static p-0'
                                        },
                                        header: utilities.html(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n                                <div class=\"d-flex align-items-center gap-2 justify-content-center w-100 h4 mb-0\">\n                                    <i class=\"fa-solid fa-check-circle text-success fw-bold\"></i>\n                                    Account created successfully\n                                </div> \n                                \n                            "], ["\n                                <div class=\"d-flex align-items-center gap-2 justify-content-center w-100 h4 mb-0\">\n                                    <i class=\"fa-solid fa-check-circle text-success fw-bold\"></i>\n                                    Account created successfully\n                                </div> \n                                \n                            "]))),
                                        body: utilities.html(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n                                <div>\n                                    You've successfully created a learninglounge account.\n                                    If you are not automatically redirected within 5 seconds please click confirm.\n                                </div>\n                            "], ["\n                                <div>\n                                    You've successfully created a learninglounge account.\n                                    If you are not automatically redirected within 5 seconds please click confirm.\n                                </div>\n                            "]))),
                                        footer: utilities.html(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n                                <div class=\"d-flex justify-content-end p-3\">\n                                    ", "\n                                </div>\n                            "], ["\n                                <div class=\"d-flex justify-content-end p-3\">\n                                    ", "\n                                </div>\n                            "])), new Element({
                                            composer: {
                                                content: utilities.html(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n                                                <button class=\"btn btn-success\">Confirm</button>\n                                            "], ["\n                                                <button class=\"btn btn-success\">Confirm</button>\n                                            "])))
                                            },
                                            events: {
                                                click: function () {
                                                    var _a;
                                                    var redirectUrl = isRootTest_1
                                                        ? ((_a = data_1 === null || data_1 === void 0 ? void 0 : data_1.ReturnUrl) !== null && _a !== void 0 ? _a : "/")
                                                        : window.location.href;
                                                    window.location.assign(redirectUrl);
                                                }
                                            }
                                        }).render())
                                    },
                                    events: {
                                        show: function () {
                                            var _a;
                                            (_a = authentication.dropdownInstance) === null || _a === void 0 ? void 0 : _a.componentInstance.hide();
                                            _spinner.remove();
                                        },
                                        shown: function () {
                                            setTimeout(function () {
                                                var _a;
                                                var redirectUrl = isRootTest_1
                                                    ? ((_a = data_1 === null || data_1 === void 0 ? void 0 : data_1.ReturnUrl) !== null && _a !== void 0 ? _a : "/")
                                                    : "/";
                                                window.location.assign(redirectUrl);
                                            }, 5000);
                                        }
                                    }
                                });
                                modal.show();
                            }
                            return [3 /*break*/, 9];
                        case 8:
                            err_1 = _h.sent();
                            _spinner.remove();
                            newError = utilities.html(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n                    <div class=\"text-danger my-3 toast-danger border border-danger   p-2 rounded shadow-sm\">\n                        <div class=\" d-flex align-items-start gap-2\">\n                            <i class=\"fa-light fa-exclamation-circle mt-1\"></i>\n                            An error occured, please try again.\n                        </div>\n                    </div>\n                "], ["\n                    <div class=\"text-danger my-3 toast-danger border border-danger   p-2 rounded shadow-sm\">\n                        <div class=\" d-flex align-items-start gap-2\">\n                            <i class=\"fa-light fa-exclamation-circle mt-1\"></i>\n                            An error occured, please try again.\n                        </div>\n                    </div>\n                "])));
                            (_g = register.errorWrapper) === null || _g === void 0 ? void 0 : _g.appendChild(newError);
                            register.errorElement = newError;
                            return [3 /*break*/, 9];
                        case 9: return [2 /*return*/];
                    }
                });
            });
        },
        render: function () {
            var _this = this;
            register.errorWrapper = utilities.html(templateObject_12 || (templateObject_12 = __makeTemplateObject(["<div></div>"], ["<div></div>"])));
            register.formElement = new Element({
                composer: {
                    content: utilities.html(templateObject_13 || (templateObject_13 = __makeTemplateObject(["\n                        <form class=\"d-flex flex-column gap-3\">\n                            ", "\n                            ", "\n                            ", "\n                            ", "\n                            ", "\n                            ", "\n                        </form>\n                    "], ["\n                        <form class=\"d-flex flex-column gap-3\">\n                            ", "\n                            ", "\n                            ", "\n                            ", "\n                            ", "\n                            ", "\n                        </form>\n                    "])), register.username.render(), register.password.render(), register.firstName.render(), register.lastName.render(), register.errorWrapper, register.submit.render())
                },
                events: {
                    input: function () {
                        var _a, _b, _c;
                        (_a = register.errorElement) === null || _a === void 0 ? void 0 : _a.remove();
                        if (register.formIsValid) {
                            (_b = register.submit.element) === null || _b === void 0 ? void 0 : _b.removeAttribute('disabled');
                        }
                        else {
                            (_c = register.submit.element) === null || _c === void 0 ? void 0 : _c.setAttribute('disabled', 'disabled');
                        }
                    },
                    submit: function (e) { return __awaiter(_this, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    e.preventDefault();
                                    return [4 /*yield*/, register.onSubmit()];
                                case 1:
                                    _a.sent();
                                    return [2 /*return*/];
                            }
                        });
                    }); }
                }
            }).render();
            return utilities.html(templateObject_14 || (templateObject_14 = __makeTemplateObject(["\n                <div class=\"d-flex flex-column px-3\">\n                    <h4 class=\"my-3\">Sign up in seconds</h4>\n                    ", "\n                </div>\n            "], ["\n                <div class=\"d-flex flex-column px-3\">\n                    <h4 class=\"my-3\">Sign up in seconds</h4>\n                    ", "\n                </div>\n            "])), register.formElement);
        }
    };
    return register;
};
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14;
